module.exports = __webpack_public_path__ + "d7118d1468bb00ad9848f33fc99e264c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/eyes.svg
// module id = Ctat
// module chunks = 0